"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _OutputString = _interopRequireDefault(require("./type/OutputString"));
var _OutputDate = _interopRequireDefault(require("./type/OutputDate"));
var _OutputBoolean = _interopRequireDefault(require("./type/OutputBoolean"));
var _OutputImage = _interopRequireDefault(require("./type/OutputImage"));
var _OutputPointer = _interopRequireDefault(require("./type/OutputPointer"));
var _excluded = ["type", "_type", "field", "object"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/OutputFactory/index.js";
function OutputFactory(_ref) {
  var type = _ref.type,
    _type = _ref._type,
    field = _ref.field,
    object = _ref.object,
    options = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  switch (_type || type) {
    case 'Email':
    case 'String':
    case 'Text':
    case 'Number':
    case 'Tel':
    case 'Enum':
      return /*#__PURE__*/_react["default"].createElement(_OutputString["default"], Object.assign({
        field: field,
        object: object
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 16,
          columnNumber: 20
        }
      }));
    case 'Boolean':
      return /*#__PURE__*/_react["default"].createElement(_OutputBoolean["default"], Object.assign({
        field: field,
        object: object
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 21,
          columnNumber: 20
        }
      }));
    case 'Date':
      return /*#__PURE__*/_react["default"].createElement(_OutputDate["default"], Object.assign({
        field: field,
        object: object
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 26,
          columnNumber: 20
        }
      }));
    case 'Image':
      return /*#__PURE__*/_react["default"].createElement(_OutputImage["default"], Object.assign({
        field: field,
        object: object
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 31,
          columnNumber: 20
        }
      }));
    case 'Pointer':
      return /*#__PURE__*/_react["default"].createElement(_OutputPointer["default"], Object.assign({
        field: field,
        object: object
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 20
        }
      }));
    case 'Component':
      return object[field];
    default:
      return null;
  }
}
var _default = OutputFactory;
exports["default"] = _default;